export const MenuIdSearch = 'SEARCH' as const;
